// What changed route (/$region/versions): family, compared versions, change category and clause in the URL; the screen is VersionsPage.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { enumWithDefault, optionalString } from "@/app/search";
import { VersionsPage } from "@/features/versions/VersionsPage";

const searchSchema = z.object({
  family: optionalString(),
  old: optionalString(),
  new: optionalString(),
  category: enumWithDefault(
    ["changed", "new", "removed", "renumbered", "changed_text", "changed_context"],
    "changed",
  ),
  clause: optionalString(),
});

const searchDefaults = { category: "changed" } satisfies Partial<z.output<typeof searchSchema>>;

export const Route = createFileRoute("/_app/$region/versions")({
  validateSearch: searchSchema,
  search: { middlewares: [stripSearchParams(searchDefaults)] },
  staticData: { crumb: "What changed" },
  component: VersionsPage,
});
